export default "__VITE_ASSET__D35NzHQM__"